// src/shared/shift-dedupe.js - one rota row per key in a save batch (v136.12, 19 Oct 2026).
//
// The rota save upserts on (staff_id, week_start, day, seq). When ONE batch carries two rows with the same key,
// Postgres refuses the whole statement ("ON CONFLICT DO UPDATE command cannot affect row a second time", 21000),
// so nothing in the batch is saved. Reported on staging by an area manager; the code is the same on live.
//
// The rule: keep the LAST row for a key (the latest edit, and what the staff app's own grid already shows, since it
// writes each draft line over the one before), and say how many were merged. Used by the Worker before the upsert
// (POST /api/shifts) and by the two AI publish paths that can produce a duplicate (src/schedule publishAiRota and
// src/uploads/rota.js publishRota: two draft lines for the same person and day, or two draft names that match the
// same person). Pure, no imports, so the Worker and the browser bundles share one copy.

export function shiftRowKey(r) {
  const seq = (r && r.seq != null && String(r.seq).trim() !== '') ? Number(r.seq) : 1;
  return String(r && r.staff_id) + '|' + String(r && r.week_start) + '|' + String(r && r.day) + '|' + (seq || 1);
}

// rows -> { rows, merged }. rows keeps the order of each key's LAST appearance; merged counts the rows dropped.
// Anything that is not an object is passed through untouched (the save's own validation rejects it, loudly).
export function dedupeShiftRows(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const lastAt = new Map();
  list.forEach(function (r, i) {
    if (r && typeof r === 'object') lastAt.set(shiftRowKey(r), i);
  });
  const out = [];
  let merged = 0;
  list.forEach(function (r, i) {
    if (!r || typeof r !== 'object') { out.push(r); return; }
    if (lastAt.get(shiftRowKey(r)) === i) out.push(r);
    else merged++;
  });
  return { rows: out, merged: merged };
}
